import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome } from '@fortawesome/pro-light-svg-icons'

import { SidebarModal, SquareIconWithBackground } from '@domain-group/suit-theme'

import useCampaign from '@hooks/useCampaign'
import useAgencySelector from '@hooks/useAgencySelector'

const PropertyMarketing = () => {
  const { hasMultipleAgencies, selectedAgencyId } = useAgencySelector()
  const initCampaign = { agency_id: hasMultipleAgencies ? undefined : selectedAgencyId }

  const { callbacks: { createCampaignModal } } = useCampaign(initCampaign)

  return (
    <SidebarModal.Button
      iconLeft={(
        <SquareIconWithBackground
          backgroundColor="#EEF1F6"
          color="blueGrey"
          icon={<FontAwesomeIcon icon={faHome} />}
        />
    )}
      showAngleIcon
      onClick={() => createCampaignModal()}
      subtitle="For selling or leasing property"
      title="Property Marketing"
    />
  )
}
export default PropertyMarketing
